import PropTypes from 'prop-types';

const DisplayGridRow = PropTypes.shape({
  id: PropTypes.string.isRequired,
});

export const DisplayGridRecordPropType = PropTypes.oneOfType([
  DisplayGridRow,
  PropTypes.arrayOf(
    PropTypes.oneOfType([DisplayGridRow, PropTypes.arrayOf(DisplayGridRow), PropTypes.arrayOf(PropTypes.arrayOf(DisplayGridRow))]),
  ),
]);
